import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

import Image from '@/components/image/image'

import * as styles from './header-image.module.scss'

export type Props = {
  title: string
  subtitle: string
  logo: {
    gatsbyImageData?: Record<string, unknown> | null
    url?: string | null
  } | null
  icon: {
    gatsbyImageData?: Record<string, unknown> | null
    url?: string | null
  } | null
  isDark: boolean
}

const HeaderImage: React.FC<Props> = ({
  title,
  subtitle,
  logo,
  icon,
  isDark
}) => {
  return (
    <header className={`${styles.header} ${isDark ? styles.dark : ''}`}>
      <Container>
        <Row>
          <Col lg={6} className="mb-4">
            <h1>
              {title}
              <span>{subtitle}</span>
            </h1>
            <Image image={icon} alt="icon" />
          </Col>
          <Col lg={6}>
            <Image image={logo} alt="logo" />
          </Col>
        </Row>
      </Container>
    </header>
  )
}

export default HeaderImage
